import { render, staticRenderFns } from "./CrudCultures.vue?vue&type=template&id=1684244a&scoped=true"
import script from "./CrudCultures.vue?vue&type=script&lang=js"
export * from "./CrudCultures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684244a",
  null
  
)

export default component.exports